import { render, staticRenderFns } from "./deleteBlog.vue?vue&type=template&id=210ea570&scoped=true&lang=html&"
import script from "./deleteBlog.vue?vue&type=script&lang=js&"
export * from "./deleteBlog.vue?vue&type=script&lang=js&"
import style0 from "./deleteBlog.vue?vue&type=style&index=0&id=210ea570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210ea570",
  null
  
)

export default component.exports